'use client';

import { createContext } from 'react';

import type { SliderRootContextInterface } from '../types/slider-root.types';

export const SliderRootContext = createContext<SliderRootContextInterface>({
  ariaLabel: '',
  setValue: () => {},
  min: 0,
  max: 100,
  step: 1,
  value: 0,
  disabled: false,
  shiftStep: null,
  reverse: false,
  forceUpdateDependency: false,
  handles: new Set(),
  ariaValuetext: '',
  tooltipPlacement: 'top',
  tooltipText: '',
});

SliderRootContext.displayName = 'Slider.Root.Context';
